package dairy.mynotes.reusablecomponents

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.sp
import dairy.mynotes.ui.theme.AppColors

@Composable
fun TextInputComponent(
    modifier: Modifier = Modifier.fillMaxWidth(),
    visualTransformation: VisualTransformation = VisualTransformation.None,
    keyboardType: KeyboardType = KeyboardType.Text,  // Control keyboard type: Text, Number, Email, Phone, etc.
    showClearIcon: Boolean = false,  // Enable close/clear icon at the end
    isError: Boolean = false,  // Control error state
    label: String,
    useSupportingText: Boolean = false,
    supportingText : String = "",
    labelStyle: TextStyle = MaterialTheme.typography.titleMedium,
    value: String,
    onValueChange: (String) -> Unit
) {
    OutlinedTextField(
        value = value,
        onValueChange = onValueChange,
        isError = isError,
        visualTransformation = visualTransformation,
        keyboardOptions = KeyboardOptions(keyboardType = keyboardType),  // Apply keyboard type
        // Typed text size
        textStyle = TextStyle(fontSize = 16.sp, color = AppColors.TextPrimary),
        label = {
            Label(
                text = label,
                textStyle = labelStyle
            )
        },
        supportingText = {
            if (useSupportingText) {
                Label(
    text = supportingText,
    textStyle = MaterialTheme.typography.bodyMedium,
                    color = AppColors.LightGray
)
            }
        },
        trailingIcon = {
            if (showClearIcon && value.isNotEmpty()) {
                IconButton(onClick = { onValueChange("") }) {
                    Text(
                        text = "✕",  // Unicode X symbol
                        style = MaterialTheme.typography.titleMedium
                    )
                }
            }
        },
        modifier = modifier
    )
}